module.exports = __webpack_public_path__ + "bedb0a514db03f3ed161a0eff4f1234e.pdf";